<template>
    <div class="identify-text-viewer bg-light">
        <pre>{{ response }}</pre>
    </div>
</template>

<script>
    export default {
        name: 'TextViewer',
        mixins: [
        ],
        components: {
            
        },
        props: {
            response: {
                type: String,
                default: '',
            },
            layer: {
                type: Object,
                default: () => {},
            },
        },
        computed: {
            
        },
    }

</script>

<style scoped lang="scss">

</style>